import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { fmtErr } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", role: "shopper" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const u = await register(f); toast.success("Account created 🎉"); nav(u.role === "merchant" ? "/merchant" : "/account"); }
    catch (err) { toast.error(fmtErr(err.response?.data?.detail)); setBusy(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start claiming Friibs in seconds.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="grid grid-cols-2 gap-2 p-1 rounded-xl bg-stone-100">
          {["shopper", "merchant"].map((r) => (
            <button key={r} type="button" onClick={() => setF({ ...f, role: r })} data-testid={`role-${r}`}
              className={`py-2 rounded-lg text-sm font-bold capitalize ${f.role === r ? "bg-white friib-shadow text-stone-900" : "text-stone-500"}`}>{r === "shopper" ? "I'm a Shopper" : "I'm a Brand"}</button>
          ))}
        </div>
        <input required placeholder="Full name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="register-name" className="w-full px-4 py-3 rounded-xl border border-stone-200 outline-none focus:border-[var(--friib)]" />
        <input type="email" required placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="register-email" className="w-full px-4 py-3 rounded-xl border border-stone-200 outline-none focus:border-[var(--friib)]" />
        <input type="password" required minLength={6} placeholder="Password (min 6 chars)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="register-password" className="w-full px-4 py-3 rounded-xl border border-stone-200 outline-none focus:border-[var(--friib)]" />
        <button disabled={busy} data-testid="register-submit" className="w-full py-3.5 rounded-full font-bold text-white disabled:opacity-60" style={{ background: "var(--friib)" }}>{busy ? "Creating…" : "Create account"}</button>
      </form>
      <p className="mt-6 text-center text-sm text-stone-500">Already have an account? <Link to="/login" className="font-bold text-[var(--friib)]">Sign in</Link></p>
    </AuthShell>
  );
}
